import React from 'react';
import { Link } from 'react-router-dom';
import ems from './em.jpg';
import ES from './ES.jpg';
import mech from './mech.jpg';

const Home = () => {

  const services = [
    {
      title: 'Industrial Wastewater Treatment',
      description: 'Advanced treatment solutions for industrial effluents with high efficiency and compliance.',
      icon: '',
      image: 'https://images.unsplash.com/photo-1533077162801-86490c593afb'
    },
    {
      title: 'Industrial Engineering Services',
      description: 'Complete engineering solutions for industrial applications.',
      icon: '',
      image: mech,
    },
    {
      title: 'IT Solutions for Industries ',
      description: 'IT infrastructure and software solutions tailored for industrial needs.',
      icon: '',
      image: ES,
    },
    {
      title: 'Water Recycling Solutions',
      description: 'Innovative recycling systems to reduce water consumption and operational costs.',
      icon: '',
      image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09'
    },
    {
      title: 'Custom ETP Design',
      description: 'Tailored effluent treatment plant designs to meet your specific requirements.',
      icon: '',
      image: 'https://images.unsplash.com/photo-1615797534094-7fde0a4861f3'
    },
    {
      title: 'ETP Manufacturing',
      description: 'High-quality manufacturing of complete ETP systems with cutting-edge technology.',
      icon: '',
      image: ems
    },
  ];

  return (
    <div className="min-h-screen">
      <div className="animated-bg"></div>

      {/* Hero Section */}
      <section className="w-full pt-36 px-4" data-testid="hero-banner">
        <div className="max-w-6xl mx-auto text-center fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            <span className="neon-text">Research and Solution</span>
          </h2>
          <h1 className="text-[1.17rem] sm:text-[1.49rem] md:text-[1.785rem] lg:text-[2.25rem] font-bold text-white leading-tight tracking-tight mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
            Tailor-made & UTILITY SAVING chemicals formulation for OPERATION of{' '}
            <span className="neon-text">COOLING TOWER</span>,{' '}
            <span className="neon-text">STP</span>,{' '}
            <span className="neon-text">ETP</span>
          </h1>
          <div className="float mx-auto" style={{
            maxWidth: '420px',
            filter: 'drop-shadow(0 0 20px rgba(167, 139, 250, 0.5)) drop-shadow(0 0 40px rgba(255, 255, 255, 0.25))'
          }}>
            <img
              src="https://customer-assets.emergentagent.com/job_09cbffbb-02fb-439e-a864-fc846b875ffa/artifacts/46d233qa_treatment-plant.png"
              alt="alt image"
              className="w-full h-auto"
              style={{
                mixBlendMode: 'lighten',
                filter: 'brightness(1.1) contrast(1.1)',
                opacity: 0.95
              }}
            />
          </div>
          <p className="text-sm md:text-base text-white/80 mt-8 max-w-2xl mx-auto">
            Leading provider of advanced Engineering solutions, modular effluent treatment plants and water treatment services.
            Delivering sustainable, efficient, and compliant solutions for industries.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mt-6 mb-10">
            <Link
              to="/contact"
              className="neon-button px-6 py-3 rounded-full text-white font-semibold text-sm"
              data-testid="hero-get-started-btn"
            >
              Get Started
            </Link>
            <Link
              to="/portfolio"
              className="glass px-6 py-3 rounded-full text-white font-semibold text-sm hover:bg-white/20 transition-all"
              data-testid="hero-view-projects-btn"
            >
              View Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-14 px-4" data-testid="services-section">
        <div className="max-w-6xl mx-auto">
          <div
            className="text-center mb-10"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              Our <span className="neon-text">Services</span>
            </h2>
            <p className="text-sm text-white/80 max-w-xl mx-auto">
              Comprehensive water treatment solutions tailored to your needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((service, index) => (
              <div
                key={index}
                className="glass-card rounded-xl p-5"
                style={{ animationDelay: `${index * 0.1}s` }}
                data-testid={`service-card-${index}`}
              >
                <div className="text-3xl mb-3">{service.icon}</div>
                <h3 className="text-lg font-bold text-white mb-2">{service.title}</h3>
                <p className="text-sm text-white/80 mb-3">{service.description}</p>
                <div className="overflow-hidden rounded-lg">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-40 object-cover transform hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-14 px-4" data-testid="why-choose-section">
        <div className="max-w-6xl mx-auto">
          <div
            className="glass-card rounded-2xl p-8"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center">
              Why Choose <span className="neon-text">Research and Solution</span>?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center" data-testid="feature-expertise">
                <div className="text-3xl mb-3"></div>
                <h3 className="text-base font-bold text-white mb-1">Expertise</h3>
                <p className="text-sm text-white/80">20+ years of industry experience</p>
              </div>
              <div className="text-center" data-testid="feature-technology">
                <div className="text-3xl mb-3"></div>
                <h3 className="text-base font-bold text-white mb-1">Technology</h3>
                <p className="text-sm text-white/80">Cutting-edge treatment solutions</p>
              </div>
              <div className="text-center" data-testid="feature-compliance">
                <div className="text-3xl mb-3"></div>
                <h3 className="text-base font-bold text-white mb-1">Compliance</h3>
                <p className="text-sm text-white/80">100% regulatory compliance</p>
              </div>
              <div className="text-center" data-testid="feature-support">
                <div className="text-3xl mb-3"></div>
                <h3 className="text-base font-bold text-white mb-1">Support</h3>
                <p className="text-sm text-white/80">24/7 customer assistance</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14 px-4" data-testid="cta-section">
        <div className="max-w-3xl mx-auto text-center">
          <div
            className="glass-card rounded-2xl p-8"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Ready to Transform Your <span className="neon-text">Industrial requirements</span>?
            </h2>
            <p className="text-sm text-white/80 mb-6">
              Contact us today for a free consultation and discover how we can help you achieve
              sustainable water management.
            </p>
            <Link
              to="/contact"
              className="neon-button px-8 py-3 rounded-full text-white font-semibold text-sm inline-block"
              data-testid="cta-contact-btn"
            >
              Contact Us Now
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="glass py-6 px-4 mt-14">
        <div className="max-w-6xl mx-auto text-center text-white/80 text-sm">
          <p>&copy; 2025 Research and Solution. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;